import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_BASE_URL}/api/auth/login`;

export const login = async (email, password) => {
  try {
    const response = await axios.post(API_URL, { email, password });
    return response.data; // Kembalikan data dari server
  } catch (error) {
    console.log(error);
    throw error.response?.data?.message || "Login gagal, coba lagi.";
  }
};
